function startRainCanvasOnce() {

  const start = () => {
    new RainCanvasBackground();
    window.removeEventListener('scroll', start);
  };

  window.addEventListener('scroll', start, { passive: true });

}

function debounce(fn, delay = 200) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(...args), delay);
  };
}

/* =====================================================
   DOM READY
===================================================== */
document.addEventListener("DOMContentLoaded", () => {

  initMenu();
  initFAQ();
  initPortfolio();
  initForm();
  initFooterYear();
  initHeroRotation();

  window.__motion = new MotionReveal();

});

/* =====================================================
   WINDOW LOAD (cięższe rzeczy)
===================================================== */
window.addEventListener("load", () => {

  initPreloader();

  const startRain = () => {
    new RainCanvasBackground();
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(startRain, { timeout: 2000 });
  } else {
    setTimeout(startRain, 600);
  }

});
function initPreloader() {

  const progressBar = document.querySelector('.progress-bar');
  const percentText = document.getElementById('progress-percent');
  const preloader = document.getElementById('preloader');
  const content = preloader?.querySelector('.preloader-content');

  if (!preloader) return;

  const DURATION = 700;
  const startTime = performance.now();

  function animate(now) {

    const progress = Math.min((now - startTime) / DURATION, 1);
    const percent = Math.floor(progress * 100);

    if (progressBar) {
      progressBar.style.width = percent + '%'; // wracamy do width (zgodnie z Twoim CSS)
    }

    if (percentText) {
      percentText.textContent = percent + '%';
    }

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {

      content.style.transition = 'transform .4s ease, opacity .4s ease';
      content.style.transform = 'scale(1.15)';
      content.style.opacity = '0';

      preloader.style.transition = 'opacity .4s ease';
      preloader.style.opacity = '0';

      setTimeout(() => {
        preloader.remove();
      }, 400);
    }
  }

  requestAnimationFrame(animate);
}
class MotionReveal {

  constructor(options = {}) {

    this.config = Object.assign({

      selector: '.motion, [data-reveal]',

      reveal: {
        offset: 80,
        easing: 0.08,
        triggerPoint: 0.2
      },

      hover: {
        strength: 6,
        easing: 0.08
      },

      mobile: {
        breakpoint: 768,
        hover: false,
        revealOffset: 24,
        revealEasing: 0.1
      }

    }, options);

    this.items = [];
    this.isMobile = window.innerWidth < this.config.mobile.breakpoint;

    this.init();
  }

  init() {

    document.querySelectorAll(this.config.selector).forEach(el => {
      this.items.push(new MotionItem(el, this.config, this.isMobile));
    });

    window.addEventListener('resize', debounce(() => {

      this.isMobile = window.innerWidth < this.config.mobile.breakpoint;

      this.items.forEach(i => i.onResize(this.isMobile));

    }, 200));

    this.loop();
  }

  loop = () => {

    for (const item of this.items) {
      item.update();
    }

    requestAnimationFrame(this.loop);
  }

  refresh() {

    this.items.forEach(i => i.updateRect());

  }

}
/* ======================
   SINGLE ITEM
====================== */
class MotionItem {

  constructor(el, config, isMobile) {

    this.el = el;
    this.config = config;
    this.isMobile = isMobile;

    this.hasMotion = el.classList.contains('motion');

    this.visible = false;
    this.activated = false;

    this.delay = parseInt(el.dataset.revealDelay || 0, 10);
    this.direction = el.dataset.reveal || 'bottom';

    const offset = isMobile
      ? config.mobile.revealOffset
      : config.reveal.offset;

    this.revealX = 0;
    this.revealY = 0;
    this.opacity = 0;

    if (this.direction === 'bottom') this.revealY = offset;
    if (this.direction === 'top') this.revealY = -offset;
    if (this.direction === 'left') this.revealX = -offset;
    if (this.direction === 'right') this.revealX = offset;

    this.hoverEnabled = this.hasMotion && (!isMobile || config.mobile.hover);

    this.mx = 0;
    this.my = 0;
    this.tx = 0;
    this.ty = 0;

    this.updateRect();
    this.observe();

    if (this.hoverEnabled) this.bindHover();

  }

  observe() {

    const trigger = this.config.reveal.triggerPoint;

    const io = new IntersectionObserver(entries => {

      entries.forEach(entry => {

        if (entry.isIntersecting && !this.activated) {

          this.activated = true;

          setTimeout(() => {
            this.visible = true;
          }, this.delay);

          io.unobserve(this.el);

        }

      });

    }, {
      rootMargin: `0px 0px -${trigger * 100}% 0px`
    });

    io.observe(this.el);

  }

  bindHover() {

    this.el.addEventListener('mouseenter', () => this.updateRect());

    this.el.addEventListener('mouseleave', () => {

      this.mx = 0;
      this.my = 0;

    });

    this.el.addEventListener('mousemove', e => {

      if (!this.visible) return;

      const { left, top, width, height } = this.rect;

      const dx = e.clientX - (left + width / 2);
      const dy = e.clientY - (top + height / 2);

      this.mx = (-dx / (width / 2)) * this.config.hover.strength;
      this.my = (-dy / (height / 2)) * this.config.hover.strength;

    });

  }

  onResize(isMobile) {

    this.isMobile = isMobile;

    this.hoverEnabled =
      this.hasMotion && (!this.isMobile || this.config.mobile.hover);

    this.updateRect();

  }

  updateRect() {

    this.rect = this.el.getBoundingClientRect();

  }

  update() {

    if (!this.visible && !this.activated) return;

    const easing = this.isMobile
      ? this.config.mobile.revealEasing
      : this.config.reveal.easing;

    /* reveal */

    this.revealX += (0 - this.revealX) * easing;
    this.revealY += (0 - this.revealY) * easing;
    this.opacity += (1 - this.opacity) * easing;

    /* hover */

    if (this.hoverEnabled) {

      this.tx += (this.mx - this.tx) * this.config.hover.easing;
      this.ty += (this.my - this.ty) * this.config.hover.easing;

    }

    const x = this.revealX + this.tx;
    const y = this.revealY + this.ty;

    this.el.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    this.el.style.opacity = this.opacity.toFixed(3);

  }

}
class RainCanvasBackground {
  constructor(options = {}) {
    if (window.innerWidth < 768) return;
    this.config = Object.assign({
      canvasId: 'rainCanvas',
      lineWidth: 1,
      lineColor: 'rgba(217,217,217,0.01)',

      dropHeight: 100,
      dropsPerLine: 3,

      baseSpeed: .05,
      maxBoost: 1.5,
      parallax: .2,

      sidePadding: 10,
      dropColor: [44, 174, 88]
    }, options);

    // canvas
    this.canvas = document.getElementById(this.config.canvasId);
    this.ctx = this.canvas.getContext('2d');

    this.lines = [];

    // scroll easing
    this.scrollTarget = window.scrollY;
    this.scrollCurrent = window.scrollY;
    this.lastScroll = window.scrollY;
    this.speedBoost = 0;

    this.isMobile = window.innerWidth < 768;

    // 🔥 stały gradient dla wszystkich kropli (cache)
    this.dropGradientTemplate = this.ctx.createLinearGradient(
      0, 0, 0, this.config.dropHeight
    );
    this.dropGradientTemplate.addColorStop(0, `rgba(${this.config.dropColor},0)`);
    this.dropGradientTemplate.addColorStop(1, `rgba(${this.config.dropColor},.5)`);

    this.resize = this.resize.bind(this);
    this.animate = this.animate.bind(this);

    this.init();
  }

  

  /* ======================
     INIT
  ====================== */
  init() {
    this.applyMobileDensity();
    this.resize();

    window.addEventListener('resize', debounce(this.resize, 200));
    window.addEventListener('scroll', () => {
  this.scrollTarget = window.scrollY;
}, { passive: true });

    this.animate();
  }

  /* ======================
     MOBILE LOW-DENSITY
  ====================== */
  applyMobileDensity() {
    if (this.isMobile) {
      this.config.dropsPerLine = 1;
      this.config.baseSpeed *= 0.7;
      this.config.parallax *= 0.6;
    }
  }

  /* ======================
     UTILS
  ====================== */
  random(min, max) {
    return Math.random() * (max - min) + min;
  }

  getLineCount(w) {
    if (w < 360) return 2;
    if (w < 640) return 3;
    if (w < 1000) return 4;
    if (w < 1280) return 5;
    return 7;
  }

  /* ======================
     RESIZE / CREATE
  ====================== */
  resize() {
    this.canvas.width = innerWidth;
    this.canvas.height = innerHeight;
    this.createLines();
  }

  createDrop(slotIndex) {
    return {
      y: -this.canvas.height * (slotIndex + 1)
         + this.random(-this.canvas.height * 0.3, this.canvas.height * 0.3),
      speed: this.random(0.8, 1.4)
      // 🔥 gradient jest już w dropGradientTemplate, nie potrzebujemy go tu
    };
  }

  createLines() {
    this.lines.length = 0;

    const count = this.getLineCount(innerWidth);
    const maxWidth = Math.min(
      1500 - this.config.sidePadding * 2,
      innerWidth - this.config.sidePadding * 2
    );
    const startX = (innerWidth - maxWidth) / 2;
    const spacing = maxWidth / (count - 1 || 1);

    for (let i = 0; i < count; i++) {
      const drops = [];
      for (let j = 0; j < this.config.dropsPerLine; j++) {
        drops.push(this.createDrop(j));
      }

      this.lines.push({
        x: Math.round(startX + i * spacing),
        drops
      });
    }
  }

  /* ======================
     SCROLL EASING
  ====================== */
  updateScroll() {
    this.scrollCurrent +=
      (this.scrollTarget - this.scrollCurrent) * 0.1;

    const delta = Math.abs(this.scrollTarget - this.lastScroll);
    this.speedBoost = Math.min(this.config.maxBoost, delta * 0.05);
    this.lastScroll = this.scrollTarget;
  }

  /* ======================
     DRAW
  ====================== */
  drawLines() {
    this.ctx.fillStyle = this.config.lineColor;
    this.lines.forEach(l =>
      this.ctx.fillRect(l.x, 0, this.config.lineWidth, this.canvas.height)
    );
  }

  drawDrops() {
    const offset = this.scrollCurrent * this.config.parallax;

    this.lines.forEach(line => {
      line.drops.forEach(drop => {
        const y = drop.y + offset % this.canvas.height;

        this.ctx.fillStyle = this.dropGradientTemplate;
        this.ctx.fillRect(
        line.x,
        y,
        this.config.lineWidth,
        this.config.dropHeight
        );

        drop.y += drop.speed + this.config.baseSpeed + this.speedBoost;

        if (drop.y > this.canvas.height + this.config.dropHeight) {
          drop.y -= this.canvas.height * this.config.dropsPerLine;
          drop.speed = this.random(0.8, 1.4);
        }
      });
    });
  }

  /* ======================
     LOOP
  ====================== */
  animate() {
    if (document.hidden){
      requestAnimationFrame(this.animate);
      return;
    }
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

    this.updateScroll();
    this.drawLines();
    this.drawDrops();

    this.speedBoost *= 0.9;
    requestAnimationFrame(this.animate);
  }
}
function initMenu(){
  
  const btn = document.querySelector('.header__btn-toggle');
  const header = document.querySelector('.header');

  btn.addEventListener('click', () => {
  const isOpen = header.classList.toggle('is-menu-open');
  btn.setAttribute('aria-expanded', isOpen);
  });

}


function initFAQ(){
  document.querySelectorAll('.faq__question').forEach(button => {
    button.addEventListener('click', () => {
  
      const item = button.parentElement;
      const isOpen = item.classList.contains('active');
  
      // Zamknij wszystkie
      document.querySelectorAll('.faq__item').forEach(el => {
        el.classList.remove('active');
        el.querySelector('.faq__question')
          .setAttribute('aria-expanded', 'false');
      });
  
      // Otwórz kliknięty jeśli był zamknięty
      if (!isOpen) {
        item.classList.add('active');
        button.setAttribute('aria-expanded', 'true');
      }
  
    });
    });
}

function initPortfolio(){
  const portfolioData = {
    "realizacja-1": {
      folder: "realizacja-1",
      name: "SPECMAL",
      link: "https://www.specmal.eu"
    },
    "realizacja-2": {
      folder: "realizacja-2",
      name: "Wesele Online",
      link: "#"
    },
    "realizacja-3": {
      folder: "realizacja-3",
      name: "Demo 1",
      link: "#"
    },
    "realizacja-4": {
      folder: "realizacja-4",
      name: "Demo 2",
      link: "#"
    },
    "realizacja-5": {
      folder: "realizacja-5",
      name: "Demo 3",
      link: "#"
    },
    "realizacja-6": {
      folder: "realizacja-6",
      name: "Demo 4",
      link: "#"
    }
  };
  
  const tabs = document.querySelectorAll(".tab");
  const devices = document.querySelectorAll(".device picture");
  const cta = document.querySelector(".portfolio__cta");
  
  
  function loadProject(projectKey) {
  
    const project = portfolioData[projectKey];
    if (!project) return;
  
    devices.forEach(device => {
  
      const img = device.querySelector("img");
      const sources = device.querySelectorAll("source");
  
      const wrapper = device.closest(".device");
      const className = [...wrapper.classList]
        .find(c => c.startsWith("device--"));
  
      const type = className.replace("device--", "");
  
      // 🔥 podmiana źródeł
      img.src = `./dist/img/portfolio/${project.folder}/${type}-preview.webp`;
  
      if (sources[0]) {
        sources[0].srcset =
          `./dist/img/portfolio/${project.folder}/${type}-preview-l.webp`;
      }
  
      if (sources[1]) {
        sources[1].srcset =
          `./dist/img/portfolio/${project.folder}/${type}-preview-m.webp`;
      }
  
    });
  
    cta.href = project.link;
    if (window.__motion) {
    window.__motion.refresh();
  }
  }
  
  tabs.forEach(tab => {
  
    if (tab.disabled) return;
  
    tab.addEventListener("click", () => {
  
      tabs.forEach(t => t.classList.remove("active"));
      tab.classList.add("active");
  
      loadProject(tab.dataset.project);
    });
  });
  
  const activeTab = document.querySelector(".tab.active");
  
  if (activeTab) {
    loadProject(activeTab.dataset.project);
  }  
}

function initForm(){
  const form = document.querySelector(".contact__form");
const successBox = document.querySelector(".form__success");

if (form) {

  const fields = {
    name: {
      min: 3,
      message: "Podaj poprawne imię i nazwisko."
    },
    email: {
      validate: (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val),
      message: "Podaj poprawny adres email."
    },
    topic: {
      min: 3,
      message: "Temat musi mieć min. 3 znaki."
    },
    message: {
      min: 10,
      message: "Wiadomość musi mieć min. 10 znaków."
    },
    privacy: {
    type: "checkbox",
    message: "Musisz zaakceptować politykę prywatności."
    }
  };

  function showError(input, message) {
    const wrapper = input.closest(".form__input");
    const errorBox = wrapper.querySelector(".form__error");

    input.classList.add("error");
    input.setAttribute("aria-invalid", "true");
    errorBox.textContent = message;
  }

  function clearError(input) {
    const wrapper = input.closest(".form__input");
    const errorBox = wrapper.querySelector(".form__error");

    input.classList.remove("error");
    input.removeAttribute("aria-invalid");
    errorBox.textContent = "";
  }

  function validateField(input) {
    const value = input.value.trim();
    const rules = fields[input.name];

    clearError(input);

    if (!rules) return true;

    if (rules.type === "checkbox") {
    if (!input.checked) {
      showError(input, rules.message);
      return false;
    }
    return true;
  }

    if (rules.min && value.length < rules.min) {
      showError(input, rules.message);
      return false;
    }

    if (rules.validate && !rules.validate(value)) {
      showError(input, rules.message);
      return false;
    }

    return true;
  }

  // Walidacja przy wpisywaniu
  form.querySelectorAll("input, textarea").forEach(input => {
  const eventType = input.type === "checkbox" ? "change" : "input";

  input.addEventListener(eventType, () => {
    validateField(input);
  });
});

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    let isValid = true;

    form.querySelectorAll("input, textarea").forEach(input => {
      if (!validateField(input)) {
        isValid = false;
      }
    });

    if (!isValid) return;

    const formData = new FormData(form);

    try {
      const response = await fetch("/dist/php/send.php", {
        method: "POST",
        body: formData
      });

      const result = await response.json();

      if (result.status === "success") {
        form.reset();
        successBox.classList.add("show");
      } else {
        alert(result.message || "Wystąpił błąd.");
      }

    } catch (error) {
      alert("Błąd połączenia z serwerem.");
    }
  });
}
}

function initFooterYear(){
  const footYear = document.getElementById("footYear");
const d = new Date();

footYear.innerHTML = d.getFullYear();
}

function initHeroRotation(){
  const titleElements = document.querySelectorAll('.hero__el');
let i = 0;

setInterval(() => {
  titleElements[i].classList.remove('is-active');
  i = (i + 1) % titleElements.length;
  titleElements[i].classList.add('is-active');
}, 3500);
}
